import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"
import CustomButton from "../../components/custom-button/custom-button.component"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"

export const Section = styled(SectionWrapper)``

export const Wrapper = styled(Container)``

export const LeftCard = styled.div`
  border-radius: 20px;
  background: var(
    --brand-gradient-2-c,
    linear-gradient(90deg, #00a179 0%, #008d8d 100%)
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 106px 74px;
  height: 100%;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 2rem;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(40)};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  max-width: 522px;
  margin-bottom: 1.2rem;

  &.right {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(28)};
    line-height: ${({ theme }) => theme.typography.pxToRem(36)};
    letter-spacing: -0.28px;
  }
`
export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(28)};
  opacity: 0.85;
  text-align: center;
  max-width: 370px;

  &.right {
    color: ${({ theme }) => theme.palette.primary.main};
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    line-height: ${({ theme }) => theme.typography.pxToRem(22)};
  }
`

export const ButtonsContainer = styled.div`
  margin-top: ${({ theme }) => theme.typography.pxToRem(48)};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  ${({ theme }) => theme.breakpoints.down("xl")} {
    button,
    a {
      font-size: 1rem;
    }
  }
  ${({ theme }) => theme.breakpoints.down("lg")} {
    flex-direction: column;
    button,
    a {
      font-size: 1rem;
      width: 100%;
    }
  }
`

export const QrButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.palette.primary.light} !important;
  color: ${({ theme }) => theme.palette.primary.main} !important;
  display: flex;
  gap: 0.2rem;

  path {
    fill: ${({ theme }) => theme.palette.primary.main};
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 100%;
  }
`

export const BgPattern = styled(CustomBgImage)`
  position: relative;
  border-radius: 20px;
  background: #d9f1eb;
  padding: 106px 74px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 2rem;
  }
`
